export const salesTrackingAdapter = (data) => {
  if (!data) {
    return [];
  }

  const newArr = [];

  const prepareData = (i) => ({
    ...i,
    mall: i.company?.shopping_center?.title,
    shop: i.company?.title,
    loyalty: i.customer_code,
    customer_code: i.customer_code,
    'shopping_centers.title': i.company?.shopping_center?.title,
    'companies.title': i.company?.title,
  });

  if (Array.isArray(data)) {
    data.forEach(i => {
      newArr.push(prepareData(i));
    });

    return newArr;
  }

  return prepareData(data);
};
